<template>
  <div>
    <div v-show="!isLoading" class="card">
      <div class="card-body" style="padding: 10px 30px; ">
        <div v-if="isTeacher" class="row" >
          <!-- <h4 class="col-md-10 col-xs-6"><span>任務</span></h4> -->
          <div class="col-md-10 col-xs-6"></div>
          <a class="col-md-2 col-xs-6" @click="open" style="font-size: 11pt; text-decoration: underline; text-align: right; cursor: pointer;">
            <i class="fa fa-edit"></i>編輯
          </a>
          <EditActivityModal ref="actModal" :activity.sync="activity"/>
        </div>
        <h1>名稱: {{activity.name}}</h1>
        <h5 v-if="!!activity.description && activity.description.length > 0">簡介: <span>{{activity.description}}</span></h5>
        <div v-if="isTeacher || files.length > 0" class="row">
          <div class="col-xs-12">學習資源</div>
          <div class="col-xs-12">
            <EditMaterialModal v-if="isTeacher" :id="0" :route="`courses/${this.courseId}/weeks/${this.weekId}/activities/${this.id}/files`" :fileProps="files" :update="fetchFiles"/>
          </div>
        </div>
        <div v-show="files.length > 0" class="container-fluid">
          <div class="row" id="activity_file_container">
            <div class='row week_material_container' style='min-height: 100px;'>
              <Material v-for="file in files" :key="file.id" :file="file"/>
            </div>
          </div>
        </div>
        <div class="row" style="margin-top: 60px; margin-bottom: 30px; text-align: center;">
          <div v-if="isTeacher" class="col-md-6 button">
            <router-link :to="{name:'ClassReportDetail', query: this.$route.query}" class="btn btn-fill btn-success" style="font-size: 20pt; color: white;">學生數據</router-link>
          </div>
          <div class="col-md-6 button">
            <ltiBtn v-if="activity.type == 'uReply'" :courseId="courseId" :activityId="id" :label="uReplyBtnLabel"></ltiBtn>
          </div>
          <div v-if="false" class="col-xs-6" style="">
            <a href="" class="btn btn-fill btn-success" style="font-size: 20pt;">評分</a>
          </div>
        </div>
      </div>
    </div>
    <Loading v-show="isLoading"></Loading>
  </div>
</template>
<style scoped>
@media screen and (max-width: 790px) {
  .button{
    padding: 1rem
  }
}
</style>
<script>
import Loading from '@/components/Utility/Loading.vue'
import Material from '@/components/Weeks/Material'
import EditMaterialModal from '@/components/Weeks/EditMaterialModal'
import EditActivityModal from '@/components/Weeks/EditActivityModal'
import ltiBtn from '@/components/Weeks/LTI_btn'
export default {
  components: {
    Loading,
    Material,
    EditMaterialModal,
    EditActivityModal,
    ltiBtn
  },
  props: {
    activity: Object,
    courseId: Number,
    weekId: Number,
    id: Number
  },
  data () {
    return {
      isLoading: true,
      files: []
    }
  },
  computed: {
    isTeacher: function () {
      return this.role === 'teacher'
    },
    isStudent: function () {
      return this.role === 'student'
    },
    role: function () {
      return this.$parent.activity.role
    },
    uReplyBtnLabel: function () {
      return this.isTeacher ? '設置uReply問題' : '開啓uReply練習'
    }
  },
  watch: {
    activity: function (a, b) {
      console.log('watch act')
      console.log(a, b)
    }
  },
  methods: {
    fetchFiles: async function () {
      await this.$store.dispatch('request', {
        route: `courses/${this.courseId}/weeks/${this.weekId}/activities/${this.id}/files`
      }).then(files => {
        console.log(files)
        this.files = files
      })
      this.isLoading = false
    },
    open: function () {
      this.$refs.actModal.open()
    }
  },
  mounted () {
    console.log(this.activity)
    this.fetchFiles()
    // this.$store.dispatch('request', {
    //   route: `courses/${this.courseId}/weeks/${this.weekId}/activities/${this.id}`
    // }).then(activity => {
    //   console.log(activity)
    //   this.name = activity.name
    //   this.description = activity.description
    //   this.activity = activity
    // })
    // },
    // updated () {
    //   console.log('updated')
    //   this.activity = this.$parent.activity
  }
}
</script>
